module.exports = _gsScope;